import { queryErrorMessage } from '~/modules/query';
import type { MlsRow } from '~/components/Constants/mlsConstants';

/**
 * A string `result` before `message`: the service's reply helpers bind `message` to the bare HTTP
 * reason phrase ("Bad Request") and put the route's reason in `result`. Only a string: on a 500
 * `result` is a serialized object, which has no place in a toast.
 */
export const mlsErrorText = (err: { data?: { result?: unknown } }): string => {
  const result = err?.data?.result;
  return typeof result === 'string'
    ? result
    : (queryErrorMessage(err) ?? 'The change could not be saved.');
};

/** The id the feed's write routes take. */
export const mlsKeyFor = (wholeRow?: MlsRow) => String(wholeRow?.feed_id ?? wholeRow?._id ?? '');

/** Runs a feed write; a failure rethrows as the sentence `useRecordSave` shows. */
export const feedWrite = (request: Promise<unknown>): Promise<unknown> =>
  request.catch((err) => {
    throw { detail: mlsErrorText(err) };
  });

/** The id the record route takes. */
export const feedId = (row: MlsRow): string => row._id ?? String(row.mlsid);
